var _circle, _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.20078,
    cy: 5.4,
    r: 2.4,
    fill: "var(--white)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.2,
    cy: 12.0006,
    rx: 4.2,
    ry: 2.4,
    fill: "var(--white)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4007 12.0003C14.4007 12.9944 13.1793 13.8003 11.6882 13.8003C12.1275 13.3201 12.4296 12.7173 12.4296 12.0011C12.4296 11.2841 12.1268 10.6808 11.6866 10.2003C13.1778 10.2003 14.4007 11.0062 14.4007 12.0003Z",
    fill: "var(--white)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6007 5.40046C12.6007 6.39458 11.7948 7.20046 10.8007 7.20046C10.5839 7.20046 10.3761 7.16215 10.1836 7.09191C10.4674 6.59266 10.6296 6.01516 10.6296 5.39979C10.6296 4.78489 10.4677 4.20779 10.1842 3.70878C10.3765 3.6387 10.5841 3.60046 10.8007 3.60046C11.7948 3.60046 12.6007 4.40635 12.6007 5.40046Z",
    fill: "var(--white)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersGroup);
export default __webpack_public_path__ + "static/media/users-group.be67b803523f0cfdea639e16511afa36.svg";
export { ForwardRef as ReactComponent };